import { render } from "./BingoCard.vue?vue&type=template&id=7c05d99a"
import script from "./BingoCard.vue?vue&type=script&lang=js"
export * from "./BingoCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__